module.exports = __webpack_public_path__ + "web/img/challenge-banner.215a8aed.png";